import { CommerceMedia, CommerceMediaCollectionItem, MediaType, PimResourceType } from '@api/types';
import { getMainContentType } from '@utils/content.utils';

export const toCommerceMedia = (collection: CommerceMediaCollectionItem[]): CommerceMedia[] =>
  collection.map((x) => x.expanded || {});

export const getCommerceMediaByType = (
  collection?: CommerceMediaCollectionItem[],
  mediaType?: MediaType,
  resourceType?: PimResourceType
) => {
  if (!collection || !mediaType) {
    return [];
  }
  let flatCollection = toCommerceMedia(collection).filter(
    (x) => getMainContentType(x?.contentType) === mediaType
  );
  if (resourceType) {
    flatCollection = flatCollection.filter((x) => x.pimResourceType === resourceType);
  }
  return flatCollection;
};
